import { IngestDefinitionRow } from "./types";

/*
    A supplementary file's spec sorts after the primary it hangs off (MPN-1564), so the
    two read as one delivery. Everything else keeps the server's order, which is by name
    — the list must not depend on database row order (MPN-1693).

    A spec whose primary feeds some other population is left where it is: dropping it
    would hide a spec, which is the defect this exists to fix.
*/
export const orderSpecs = (specs: IngestDefinitionRow[]) => {
  const ids = new Set(specs.map((d) => d.id));
  const dependents = specs.filter((d) => d.depends_on && ids.has(d.depends_on.id));
  const primaries = specs.filter((d) => !dependents.includes(d));
  return [
    ...primaries.flatMap((p) => [p, ...dependents.filter((d) => d.depends_on?.id === p.id)]),
    ...dependents.filter((d) => !primaries.some((p) => p.id === d.depends_on?.id)),
  ];
};
